export const MODE_KEYS = ["fast", "normal", "gourmet"];

export const MODE_LABELS = {
  fast: "Hızlı",
  normal: "Normal",
  gourmet: "Gurme",
};

export const MODE_FIELDS = [
  { key: "firstWaterRatio",      label: "İlk Su oranı",            short: "İlk Su",   range: [10, 100] },
  { key: "cookingTemperature",   label: "Pişirme Sıcaklığı (°C)",  short: "Sıcak.",   range: [87, 98] },
  { key: "maxCookingTime",       label: "Max Pişirme Süresi",      short: "Max Süre", range: [1, 10] },
  { key: "serviceDown",          label: "Servis Aşağı",            short: "Servis",   range: [1, 15] },
  { key: "halfPowerTemperature", label: "Yarı Güç (°C)",           short: "Yarı Güç", range: [50, 90] },
  { key: "halfPowerPercentage",  label: "Yarı Güç Yüzdesi",        short: "YG %",     range: [30, 100] },
  { key: "mixerSpeed",           label: "Karıştırma Hızı",         short: "Kar. Hız", range: [1, 20] },
  { key: "firstMixerTime",       label: "İlk Karıştırma Süresi",   short: "İlk Kar.", range: [1, 20] },
  { key: "halfPowerMixerRatio",  label: "Yarı Güç Karıştırma Oranı", short: "YG Kar.", range: [30, 100] },
];

export const CUP_NAME_REGEX = /^\S{1,7}$/;
export const WATER_LEVEL_RANGE = [10, 300];
export const MODE_FIELD_DEFAULTS = {
  firstWaterRatio: 60, cookingTemperature: 92, maxCookingTime: 5,
  serviceDown: 5, halfPowerTemperature: 85, halfPowerPercentage: 50,
  mixerSpeed: 10, firstMixerTime: 10, halfPowerMixerRatio: 40,
};
